import {
  PaymentFrequency,
  PaymentType,
  VehicleInterface,
} from '@vw-marketing/vw-ca-types';
import { DealerData } from './globalapi';

export enum ModelKey {
  TAOS = 'taos',
  GOLFGTI = 'golfgti',
  GOLFR = 'golfr',
  TIGUAN = 'tiguan',
  ATLAS = 'atlas',
  CROSSSPORT = 'atlascrosssport',
  JETTA = 'jetta',
  JETTAGLI = 'jettagli',
  ID4 = 'id4',
  IDBUZZ = 'idbuzz'
};

export interface Offer {
  type: PaymentType;
  label: string;
  price: string;
  term: number;
  rate: number;
  downpayment: string;
  payment: string;
  frequency: PaymentFrequency;
  legal: string;
  end_date: string;
  bonus_cash: string;
  bonus_offer: string;
  bonus_offer_legal: string;
};

export interface Trim {
  lead: boolean;
  engine: string;
  transmission: string;
  trimline: string;
  sales_code: string;
  exterior_code: string;
  exterior_name: string;
  background_color: string;
  default_payment: PaymentType;
  offers: Offer[];
  bonus_offer?: string;
  bonus_offer_legal?: string;
};

export interface ModelOffers {
  year: string;
  name: string;
  trims: Trim[];
  singleTrim?: boolean;
  vehicle?: VehicleInterface;
  dealer?: DealerData;
  type?: string;
  source?: string;
};

export type OffersByYear = {
  [key in ModelKey]?: ModelOffers;
}

export type AllOffers = {
  [key: string]: OffersByYear;
};

export type SimpleConfig = {
  year: string;
  name: string;
};

export type FullConfig = ModelOffers;

export type OffersFAConfig = SimpleConfig | FullConfig;
